module.exports = __webpack_public_path__ + "static/media/phone.077ab9c2.svg";